import { ReactElement } from 'react';
import { Outlet, Navigate, NavLink } from 'react-router-dom';
import { PartnerAdminTopBar } from '../PartnerAdminTopBar';
import classes from './PartnerAdminLayout.module.css';
import { useGetUserinfo } from '../../hooks/queries/useGetUserinfo';
import { UserRoles } from '../../api/queries';
import { PageLoader } from '../PageLoader/PageLoader';
import { Routes } from '../../enums/Routes';
import { useRouterMetadataContext } from '../../contexts/routerMetaDataContext';

const isPartnerAdmin = (userRoles?: string[]): boolean => {
  return userRoles?.includes(UserRoles.PARTNER_ADMIN) ?? false;
};

export const PartnerAdminLayout = (): ReactElement => {
  const { data: userInfo, isLoading } = useGetUserinfo();
  const { shouldBeInFocusMode } = useRouterMetadataContext();

  if (isLoading) {
    return <PageLoader />;
  }

  if (!isPartnerAdmin(userInfo?.userRoles)) {
    return <Navigate to={Routes.Dashboard} replace />;
  }

  return (
    <div className={classes.container}>
        {!shouldBeInFocusMode && <PartnerAdminTopBar />}
        {!shouldBeInFocusMode && (
          <nav className={classes.navigation}>
          <NavLink
            to={Routes.PartnerAdminDashboard}
            className={({ isActive }) =>
              isActive ? `${classes.navLink} ${classes.active}` : classes.navLink
            }
            aria-label="Gå til Dashboard"
          >
            Dashboard
          </NavLink>
          <NavLink
            to={Routes.PartnerAdminCustomers}
            className={({ isActive }) =>
              isActive ? `${classes.navLink} ${classes.active}` : classes.navLink
            }
            aria-label="Gå til Kunder"
          >
            Kunder
          </NavLink>
          <NavLink
            to={Routes.PartnerAdminLeads}
            className={({ isActive }) =>
              isActive ? `${classes.navLink} ${classes.active}` : classes.navLink
            }
            aria-label="Gå til Leads"
          >
            Leads
          </NavLink>
          <NavLink
            to={Routes.PartnerAdminCashback}
            className={({ isActive }) =>
              isActive ? `${classes.navLink} ${classes.active}` : classes.navLink
            }
            aria-label="Gå til Cashback"
          >
            Cashback
          </NavLink>
        </nav>
      )}
      <main className={classes.main}>
        <Outlet />
      </main>
    </div>
  );
};
